<span
  class="font-weight-bold fs-16 text-marine-blue-two"
  *scText="rendering.fields.foreignBankDetails"
></span>
<div class="line"></div>
<div class="row" [formGroup]="foreignBankForm">
  <div class="col-xl-9 col-lg-11">
    <!-- BENEFICIARY BANK -->
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label
            *scText="formFields.fields.internationalBeneficiaryBankDD.label"
          ></label>
          <div class="bank-selector">
            <mat-form-field class="d-block ab-select" [floatLabel]="'never'" hideRequiredMarker>
              <mat-select
                formControlName="beneficiaryBankType"
                (openedChange)="touch()"
              >
                <mat-option
                  *ngFor="
                    let value of formFields.fields
                      .internationalBeneficiaryBankDD.values
                  "
                  [value]="value.fields.label.value"
                >
                  {{ value.fields.label.value }}</mat-option
                >
              </mat-select>
            </mat-form-field>
            <div class="w-100">
              <input
                (blur)="beneficiaryBankValidationBic()"
                formControlName="beneficiaryBankValue"
                type="text"
                class="form-control form-control-custom"
                #beneficiaryBankValueInput
                [maxlength]="beneficiaryBankMaxLength"
              />

              <span
                class="field-validation-error"
                *ngIf="beneficiaryBankValue.errors?.required"
                >{{ formFields.genericErrors.required.message }}</span
              >
              <span
                class="field-validation-error"
                *ngIf="beneficiaryBankValue.errors?.bicInvalid"
                >{{ formFields.genericErrors.validationBICorABA.message }}</span
              >
              <span
                class="field-validation-error"
                *ngIf="beneficiaryBankValue.errors?.pattern"
                >{{
                  beneficiaryBankType.value === 'ABA'
                    ? formFields.genericErrors.validationBICorABA.message
                    : formFields.genericErrors.validationBICLength.message
                }}</span
              >
              <span
                class="field-validation-error"
                *ngIf="
                  beneficiaryBankValue.errors?.minlength ||
                  beneficiaryBankValue.errors?.maxlength
                "
                >{{
                  beneficiaryBankType.value === 'ABA'
                    ? formFields.genericErrors.validationABALength.message
                    : formFields.genericErrors.validationBICLength.message
                }}</span
              >
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="beneficiaryBank && beneficiaryBank.name !== ''"
        class="col-md-6"
      >
        <label>&nbsp;</label>
        <div class="bank-name">
          {{ beneficiaryBank.name }}<br />
          {{ beneficiaryBank.city }}
        </div>
      </div>
    </div>
    <!-- BENEFICIARY BANK -->

    <!-- INTERMEDIARY BANK -->
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label
            *scText="formFields.fields.intermediaryBeneficiaryBankDD.label"
          ></label>
          <div class="bank-selector">
            <mat-form-field class="d-block ab-select" [floatLabel]="'never'" hideRequiredMarker>
              <mat-select
                formControlName="intermediaryBankType"
                (openedChange)="touch()"
              >
                <mat-option
                  *ngFor="
                    let value of formFields.fields.intermediaryBeneficiaryBankDD
                      .values
                  "
                  [value]="value.fields.label.value"
                >
                  {{ value.fields.label.value }}</mat-option
                >
              </mat-select>
            </mat-form-field>
            <div class="w-100">
              <input
                (blur)="intermediaryBankValueValidationBic()"
                formControlName="intermediaryBankValue"
                type="text"
                class="form-control form-control-custom"
                #intermediaryBankValueInput
                [maxlength]="intermediaryBankMaxLength"
              />

              <span
                class="field-validation-error"
                *ngIf="intermediaryBankValue.errors?.required"
                >{{ formFields.genericErrors.required.message }}</span
              >

              <span
                class="field-validation-error"
                *ngIf="intermediaryBankValue.errors?.bicInvalid"
                >{{ formFields.genericErrors.validationBICorABA.message }}</span
              >
              <span
                class="field-validation-error"
                *ngIf="intermediaryBankValue.errors?.pattern"
                >{{
                  intermediaryBankType.value === 'ABA'
                    ? formFields.genericErrors.validationBICorABA.message
                    : formFields.genericErrors.validationBICLength.message
                }}</span
              >
              <span
                class="field-validation-error"
                *ngIf="
                  intermediaryBankValue.errors?.minlength ||
                  intermediaryBankValue.errors?.maxlength
                "
                >{{
                  intermediaryBankType.value === 'ABA'
                    ? formFields.genericErrors.validationABALength.message
                    : formFields.genericErrors.validationBICLength.message
                }}</span
              >
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="intermediaryBank && intermediaryBank.name !== ''"
        class="col-md-6"
      >
        <label>&nbsp;</label>
        <div class="bank-name">
          {{ intermediaryBank.name }}<br />
          {{ intermediaryBank.city }}
        </div>
      </div>
    </div>
    <!-- INTERMEDIARY BANK -->

    <!-- FOREIGN BANK CHARGES -->
    <ng-container *ngIf="!hideCharges">
      <div class="row">
        <div class="col-md-6">
          <div class="d-flex">
            <label *scText="fields.foreignBankChargesLabel.title"></label>
            <ng-template #tipContent
              ><div *scRichText="fields.foreignBankChargesLabel.text"></div
            ></ng-template>
            <i
              class="icon-info-circle tooltip-icon"
              tooltipClass="tooltip-html"
              [ngbTooltip]="tipContent"
              placement="bottom"
            ></i>
          </div>
          <mat-radio-group
            class="ab-radio-group mt-1"
            formControlName="swiftFeePayeeMethod"
          >
            <mat-radio-button
              class="ab-radio"
              [value]="formFields.fields.sharedCost.defaultValue"
            >
              <span
                class="text-greyish-brown text-transform-none"
                *scText="formFields.fields.sharedCost.label"
              ></span>
            </mat-radio-button>
            <mat-radio-button
              class="ab-radio"
              [value]="formFields.fields.costForSender.defaultValue"
            >
              <span
                class="text-greyish-brown text-transform-none"
                *scText="formFields.fields.costForSender.label"
              ></span>
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div
        class="fs-14 mb-2 mt-2 foreign-bank-text"
        *scRichText="fields.foreignBankChargesHint.text"
      ></div>
    </ng-container>
    <!-- FOREIGN BANK CHARGES -->
  </div>
</div>
